import { z } from "zod";

export const categorySchema = z.object({
  id: z.number(),
  content: z.string(),
  question_count: z.number(),
  sub_category_count: z.number(),
  completed_sub_category_count: z.number(),
  is_answered: z.coerce.boolean(),
});

export type Category = z.infer<typeof categorySchema>;
